import React from 'react';
import { DistributionGainsType } from 'utils/types';
import { useQuery } from '@apollo/client';
import {
  DistributionGainsSeriesDocument as GainsSeriesQuery,
  DistributionGainsSeriesQuery as GainsSeriesResult,
  DistributionLossesSeriesQuery as LossesSeriesResult,
  DistributionGainsSeriesQueryVariables as Vars,
  DistributionLossesSeriesDocument as LossesSeriesQuery,
  DistributionGainsSeriesPortfolioDocument as GainsSeriesPortfolioQuery,
  DistributionGainsSeriesPortfolioQuery as GainsSeriesPortfolioResult,
  DistributionLossesSeriesPortfolioDocument as LossesSeriesPortfolioQuery,
  DistributionLossesSeriesPortfolioQuery as LossesSeriesPortfolioResult,
  GlobalFilterInput,
  LabelSeriesPoint,
} from 'generated/signals-graphql';

import Choropleth from './ChoroplethMapWithTooltip';
import { Spinner } from 'react-bootstrap';

interface Props {
  clientID: string;
  globalFilter: GlobalFilterInput;
  type: string;
  portfolio?: boolean;
}

const ChoroplethMap: React.FC<Props> = ({ clientID, globalFilter, type, portfolio }) => {
  const variables = {
    clientID,
    globalFilter,
  };

  const isGainsType = type === DistributionGainsType;

  const query = isGainsType ? GainsSeriesQuery : LossesSeriesQuery;

  const series = useQuery<GainsSeriesResult | LossesSeriesResult, Vars>(query, {
    variables,
    skip: portfolio,
  });

  const portfolioQuery = isGainsType ? GainsSeriesPortfolioQuery : LossesSeriesPortfolioQuery;

  const portfolioSeries = useQuery<GainsSeriesPortfolioResult | LossesSeriesPortfolioResult, Vars>(
    portfolioQuery,
    {
      variables,
      skip: !portfolio,
    }
  );

  const gains =
    portfolio && isGainsType
      ? (portfolioSeries.data as GainsSeriesPortfolioResult)?.distributionGainsSeriesPortfolio
      : (series.data as GainsSeriesResult)?.distributionGainsSeries;

  const losses =
    portfolio && type !== DistributionGainsType
      ? (portfolioSeries.data as LossesSeriesPortfolioResult)?.distributionLossesSeriesPortfolio
      : (series.data as LossesSeriesResult)?.distributionLossesSeries;

  const MapReady =
    gains || losses ? (
      <Choropleth
        typeOfDistribution={type}
        data={isGainsType ? (gains as LabelSeriesPoint[]) : (losses as LabelSeriesPoint[])}
      />
    ) : null;

  return series.loading || portfolioSeries.loading ? (
    <Spinner animation="border" role="status" variant="primary" />
  ) : (
    MapReady
  );
};

export default ChoroplethMap;
